import React, { useState } from "react";
import { 
  Row, Col, Card, CardBody, Label, Input, 
  InputGroup, InputGroupText, Button, Badge 
} from "reactstrap";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../Reducer/loaderSlice";
import { toast } from "react-toastify";

const CottonCalculator = () => {
  const dispatch = useDispatch();

  // Kandi States
  const [kandiData, setKandiData] = useState({ kandi_price: "", kg: "" });
  const [kandiResult, setKandiResult] = useState(null);

  // Conversion States
  const [convData, setConvData] = useState({ kg: "", quintal: "" });

  // 1. Instant Unit Converter
  const handleConversion = (type, value) => {
    if (!value || value <= 0) {
      setConvData({ kg: type === 'kg' ? value : "", quintal: type === 'quintal' ? value : "" });
      return;
    }

    if (type === 'kg') {
      const qVal = (parseFloat(value) / 100).toFixed(3);
      setConvData({ kg: value, quintal: qVal });
    } else {
      const kgVal = (parseFloat(value) * 100).toFixed(3);
      setConvData({ kg: kgVal, quintal: value });
    }
  };

  // 2. Kandi Calculation (Rounding Fix)
  const handleKandiCalc = (e) => {
    e.preventDefault();
    const marketPrice = parseFloat(kandiData.kandi_price);
    const totalWeight = parseFloat(kandiData.kg);
    const KANDI_BASE_WEIGHT = 355.6;

    if (!marketPrice || !totalWeight) {
      return toast.warning("Enter Price & Weight");
    }

    dispatch(loadingTrue());

    // --- EXACT CALCULATOR MATCHING LOGIC ---
    
    // Step A: Calculate raw rate per KG
    const rawRatePerKg = marketPrice / KANDI_BASE_WEIGHT; 
    
    // Step B: Round the rate to 2 decimal places FIRST (Exactly like the system calculator)
    // 58000 / 355.6 = 163.1046... becomes 163.10
    const roundedRatePerKg = Math.round(rawRatePerKg * 100) / 100;

    // Step C: Multiply the rounded rate by the total weight
    // 163.10 * 2721.6 = 443892.96
    const finalAmount = roundedRatePerKg * totalWeight;

    const totalQuintals = totalWeight / 100;

    setKandiResult({
      total_amount: finalAmount,
      rate_per_kg: roundedRatePerKg.toFixed(2),
      quintal: totalQuintals.toFixed(3),
      kandi_kg: KANDI_BASE_WEIGHT
    });

    setTimeout(() => {
      dispatch(loadingFalse());
    }, 300);
  };

  return (
    <div className="page-container p-1 bg-light min-vh-100">
      <div className="text-center mb-5">
        <h2 className="fw-bold text-theme mb-1">Cotton Mill Utility Hub</h2>
        <p className="text-muted">Pro-tools for instant industry calculations</p>
      </div>

      <Row className="justify-content-center">
        <Col lg={11}>
          
          {/* QUICK CONVERTER */}
          <Card className="border-0 shadow-sm mb-4 overflow-hidden" style={{ borderRadius: '20px' }}>
            <div className="bg-theme text-white px-4 py-2 d-inline-block" style={{ borderBottomRightRadius: '20px', width: 'fit-content' }}>
               <small className="fw-bold"><i className="bx bx-bolt-circle me-1"></i> QUICK CONVERTER</small>
            </div>
            <CardBody className="px-5 py-4">
              <Row className="align-items-center justify-content-center g-3">
                <Col md={4}>
                  <InputGroup size="lg" className="shadow-sm rounded-4 overflow-hidden border">
                    <InputGroupText className="bg-white border-0 text-success fw-bold small">KG</InputGroupText>
                    <Input 
                      type="number" 
                      placeholder="Enter Kilograms" 
                      className="border-0 shadow-none text-center fw-bold"
                      value={convData.kg}
                      onChange={(e) => handleConversion('kg', e.target.value)}
                    />
                  </InputGroup>
                </Col>
                
                <Col md={1} className="text-center">
                   <div className="bg-light rounded-circle d-inline-flex align-items-center justify-content-center border shadow-sm" style={{ width:'40px', height:'40px' }}>
                      <i className="bx bx-transfer text-theme fs-5"></i>
                   </div>
                </Col>

                <Col md={4}>
                  <InputGroup size="lg" className="shadow-sm rounded-4 overflow-hidden border">
                    <InputGroupText className="bg-white border-0 text-success fw-bold small">QUINTAL</InputGroupText>
                    <Input 
                      type="number" 
                      placeholder="Enter Quintals" 
                      className="border-0 shadow-none text-center fw-bold"
                      value={convData.quintal}
                      onChange={(e) => handleConversion('quintal', e.target.value)}
                    />
                  </InputGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Row className="g-4">
            <Col md={7}>
              <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '25px' }}>
                <CardBody className="p-5">
                  <div className="d-flex align-items-center mb-4">
                    <div className="bg-theme text-white p-2 rounded-3 me-3">
                      <i className="bx bx-calculator fs-3"></i>
                    </div>
                    <div>
                      <h4 className="fw-bold mb-0">Kandi Rate Analysis</h4>
                      <small className="text-muted">Payable amount based on 355.6 KG base</small>
                    </div>
                  </div>

                  <Row>
                    <Col md={12} className="mb-4">
                      <Label className="fw-bold text-dark small text-uppercase">Market Kandi Price</Label>
                      <InputGroup className="input-group-custom shadow-sm rounded-3 overflow-hidden border">
                        <InputGroupText className="bg-light border-0">₹</InputGroupText>
                        <Input 
                          type="number" 
                          className="form-control-lg border-0" 
                          placeholder="e.g. 58000"
                          value={kandiData.kandi_price}
                          onChange={(e) => setKandiData({...kandiData, kandi_price: e.target.value})}
                        />
                      </InputGroup>
                    </Col>

                    <Col md={12} className="mb-4">
                      <Label className="fw-bold text-dark small text-uppercase">Total Gross Weight</Label>
                      <InputGroup className="input-group-custom shadow-sm rounded-3 overflow-hidden border">
                        <Input 
                          type="number" 
                          className="form-control-lg border-0" 
                          placeholder="0.00"
                          value={kandiData.kg}
                          onChange={(e) => setKandiData({...kandiData, kg: e.target.value})}
                        />
                        <InputGroupText className="bg-light border-0 fw-bold">KG</InputGroupText>
                      </InputGroup>
                    </Col>
                  </Row>

                  <Button className="add-btn w-100 py-3 rounded-3 shadow-sm border-0 fw-bold fs-5 mt-2" onClick={handleKandiCalc}>
                    CALCULATE NOW
                  </Button>
                </CardBody>
              </Card>
            </Col>

            <Col md={5}>
              <Card className="border-0 shadow-sm bg-theme text-white h-100" style={{ borderRadius: '25px', background: 'linear-gradient(180deg, #1008C3 0%, #080479 100%)', }}>
                <CardBody className="p-5 d-flex flex-column">
                  <h5 className="text-uppercase opacity-50 small fw-bold mb-4">Calculation Summary</h5>
                  
                  <div className="mb-auto">
                    <p className="mb-1 opacity-75">Total Net Payable</p>
                    <h1 className="fw-bold display-4 text-warning mb-4">
                      ₹ {kandiResult ? kandiResult.total_amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
                    </h1>

                    <div className="p-3 rounded-4 bg-white bg-opacity-10 border border-white border-opacity-10">
                      <div className="d-flex justify-content-between mb-3 align-items-center">
                        <span className="opacity-75">Rate Per KG</span>
                        <Badge color="light" pill className="text-dark py-2 px-3 fw-bold">₹ {kandiResult?.rate_per_kg || '0.00'}</Badge>
                      </div>
                      <div className="d-flex justify-content-between mb-3">
                        <span className="opacity-75">Total Quintals</span>
                        <span className="fw-bold fs-5">{kandiResult?.quintal || '0.000'} Q</span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span className="opacity-75">Kandi Base Weight</span>
                        <span className="fw-bold">{kandiResult?.kandi_kg || '355.6'} KG</span>
                      </div>
                    </div>
                  </div>

                  <div className="mt-5 pt-3 border-top border-white border-opacity-10 text-center">
                     <p className="small mb-0 opacity-50"><i className="bx bx-info-circle me-1"></i>Standard 1 Kandi = 355.6 KG</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default CottonCalculator;